import axios from '../axios';

const fetchTemplates = async (botId: string, botType: string) => {
  const { data } = await axios.get(`/templates/${botId}/${botType}`);

  return data;
};

export default fetchTemplates;
